import { generatePath } from 'react-router-dom';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS
} from '../../constants/paths.constants';

export const ADMIN_SCHOOL_SCHOOLS_RESOURCE = {
  key: 'ADMIN_SCHOOL_SCHOOLS_RESOURCE',
  getDetailPath: (data) => {
    return generatePath(
      `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`,
      { netId: data.netId, managementId: data.managementId, communityId: data.communityId, schoolId: data.id }
    );
  },
  table: {
    title: 'Scholen',
    defaultSort: 'name',
    dataLocation: '_embedded.schools.result',
    metaLocation: '_embedded.schools.meta',
    disablePagination: true,
    searchParams: ['name'],
    fields: [
      { value: 'name', label: 'Naam', show: true, order: 0 },
      { value: 'fullName', label: 'Volledige Naam', show: true, order: 1 },
      { value: 'postcode', label: 'Postcode', show: true, order: 2 },
      { value: 'district', label: 'Gemeente', show: true, order: 3 },
      { value: 'streetName', label: 'Straatnaam', show: true, order: 4 },
      { value: 'houseNumber', label: 'Huisnummer', show: true, order: 5 },
      { value: 'province', label: 'Provincie', show: true, order: 6 }
    ],
    highlight: (item) => !!item.isManual
    // dataTransform: (data) =>
    //   data?.map((i) => ({
    //     ...i
    //   }))
  },
  api: {
    get: () => {
      throw new Error('replace api.get for ADMIN_SCHOOL_SCHOOLS_RESOURCE');
    }
  }
};
